/**
 * id of the quiz options `<form>`. Shared so the settings-stage save control
 * can trigger the form via `requestSubmit()` without duplicating the literal.
 */
export const QUIZ_OPTIONS_FORM_ID = 'quiz-options-form';
